












import { Vue, Component } from 'vue-property-decorator'

import Localization from './components/Localization.vue'

  interface IProject {
    title: string
    subtitle: string
    name: string
  }

@Component({
  name: 'v-localization',

  components: {
    'c-localization-table': Localization
  }
})
export default class LocalizationPage extends Vue {
  currentProject: string = 'web'
  projects: IProject[] = [
    {
      title: 'Web',
      subtitle: 'Локализация сайта',
      name: 'web'
    },
    {
      title: 'Mobile',
      subtitle: 'Локализация мобильной версии',
      name: 'mobile'
    },
    {
      title: 'Админка',
      subtitle: 'Локализация админки',
      name: 'admin'
    }
  ]

  protected edit (): void {}

  protected changeProject (project: string): void {
    this.currentProject = project
  }

  protected addProject (): void {}
}
